import { TimelineItemBase } from "react-calendar-timeline";

import { Moment } from "moment";

import { CropItemData, PracticeSlug } from "models";

export enum PRACTICE_TYPE {
  MAIN_CROP = "MAIN_CROP",
  UNDERSOWING_CROP = "UNDERSOWING_CROP",
  COVER_CROP = "COVER_CROP",
  FERTILIZER = "FERTILIZER",
  TILLAGE = "TILLAGE",
  SEEDING = "SEEDING",
  UNKNOWN = "UNKNOWN",
  SIDE_CROP_RECOMMENDATION = "SIDE_CROP_RECOMMENDATION",
}

export enum GROUP_TYPE {
  MAIN_CROP = 0,
  SIDE_CROP = 4,
}

export enum UPDATE_TYPE {
  START = "START",
  END = "END",
  MOVE = "MOVE",
}

export type TillageValue = {
  name: string;
  startDate?: string | null;
  endDate: string | null;
  type: PracticeSlug;
  isBaseline: boolean;
  isConfirmed: boolean;
  isMandatory: boolean;
  payout?: number;
  soilPlus3DataCollection: boolean;
  tillageDepthSoilPlus3DataCollection: boolean;
};
export type SeedingValue = {
  name: string;
  startDate?: string | null;
  endDate: string | null;
  seedingPracticeId: string | null;
  soilPlus3DataCollection: boolean;
  isBaseline: boolean;
  isConfirmed: boolean;
  isMandatory: boolean;
  payout?: number;
};
export type FertilizerValue = {
  name: string;
  startDate?: string | null;
  endDate: string | null;
  type: PracticeSlug;
  isBaseline: boolean;
  isConfirmed: boolean;
  isMandatory: boolean;
  payout?: number;
  soilPlus3DataCollection: boolean;
};
export type TillageItemData = {
  tillageValues: TillageValue[];
};
export type FertilizerItemData = {
  fertilizerValues: FertilizerValue[];
};
export type SeedingItemData = {
  seedingValue: SeedingValue;
};
export type TimelineCalendarItemsFieldDetailsProps<T extends CropItemData | TillageItemData | FertilizerItemData | SeedingItemData> = {
  practiceType: PRACTICE_TYPE;
  cropItemId?: string;
  isPlaceholder?: boolean;
  data: T;
};
export type TimelineCalendarItemsProps<T extends CropItemData | TillageItemData | FertilizerItemData | SeedingItemData> =
  TimelineCalendarItemsFieldDetailsProps<T> & TimelineItemBase<Moment>;
